import TopMenu from "../../TopMenu";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { companyId } from "../../../../utils/companyId";
import TableDocument from "../../TableDocument";
import { get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";

const Main = () => {
  const { user } = useUser();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [url, setUrl] = useState("/heatEquipment/heatEquipmentDoc");
  const [filterObj, setFilterObj] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [Doc, setDoc] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const toggleData = [
    {
      title: "Consumption by Equipment",
      url: "/heatEquipment/heatEquipmentDoc",
    },
    {
      title: "Consumption by Facility",
      url: "/heatFacility/heatConsumbtionByFacilityDoc",
    },
  ];

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Equipment",
      key: "equipment",
      field: "equipment",
    },
    {
      title: "Brand",
      key: "brand",
    },
    {
      title: "Model",
      key: "model",
    },
  ].filter(Boolean);

  const heading2 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Vendor",
      key: "vendor",
      field: "VendorLegalFullName",
    },
    {
      title: "Previous Meter Reading",
      key: "previousMeterReading",
    },
    {
      title: "Current Meter Reading",
      key: "currentMeterReading",
    },
    {
      title: "Energy Consumption",
      key: "unitOfConsumption",
    },
  ].filter(Boolean);

  const [toggleHeding, SetHeading] = useState(heading);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Equipment Type": false,
    Equipment: false,
  });
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    equipmentType: [],
    industrialEquipment: [],
  });
  const [columnWidth, setcolumnWidth] = useState(
    user?.companyAdmin ? "12% 15% 15% 15% 15% 16% 8%" : "12% 20% 20% 18% 18% 8%"
  );
  const filters = ["Date", "Equipment Type", "Equipment"];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope2${url}`);
      const data = response.data.data;

      const uniqueEquipment = [
        ...new Set(
          data.map((el) => el.equipment?.equipment) // Filter out undefined values
        ),
      ];
      const uniqueBrand = [
        ...new Set(
          data.map((el) => el.brand) // Filter out undefined values
        ),
      ];
      const uniqueModel = [
        ...new Set(
          data.map((el) => el.model) // Filter out undefined values
        ),
      ];
      setFilterOptions({
        equipment: uniqueEquipment,
        brand: uniqueBrand,
        model: uniqueModel,
      });
      return {
        equipment: uniqueEquipment,
        brand: uniqueBrand,
        model: uniqueModel,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    sortConfig,
    searchQuery,
    filterObj,
    url,
    fromDate,
    toDate,
    selectedFacility,
  ]);

  const fetchData = async (filters = filterObj) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
        search: searchQuery,
        facilityList: selectedFacility.join(","),
      }).toString();
      const response = await get(
        `/scope2/${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data); // Update the user list
      setDoc(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      setPage(response.data.currentPage); // Update current page
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Equipment",
      type: "option",
      key: "equipment",
      value: filterOptions.equipment,
    },
    {
      title: "Brand",
      type: "option",
      key: "brand",
      value: filterOptions.brand,
    },
    {
      title: "Model",
      type: "option",
      key: "model",
      value: filterOptions.model,
    },
    // {
    //   title: "Freight Load (Tonnes)",
    //   type: "limit",
    //   key: "load",
    //   value: ["one", "two"],
    // },
  ];

  const filterData2 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },

    {
      title: "Previous Reading",
      type: "limit",
      key: "PreviousMeterReading",
      value: ["one", "two"],
    },
    {
      title: "Current Reading",
      type: "limit",
      key: "CurrentMeterReading",
      value: ["one", "two"],
    },
    {
      title: "Energy Consumption",
      type: "limit",
      key: "UnitConsumption",
      value: ["one", "two"],
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    // selectedOption === "Consumption by Equipment" ?

    // setFilterObj((prev)=>{
    //   ...prev,
    //   newFilterObj
    // })
    // : setFilterObj((prev) => ({
    //   ...prev,
    //   // ...newFilterObj,
    //   ...(newFilterObj?.PreviousMeterReading && {
    //     minPreviousMeterReading: newFilterObj.PreviousMeterReading.min || undefined,
    //     maxPreviousMeterReading: newFilterObj.PreviousMeterReading.max || undefined,
    //   }),
    //   ...(newFilterObj?.CurrentMeterReading && {
    //     minCurrentMeterReading: newFilterObj.CurrentMeterReading.min || undefined,
    //     maxCurrentMeterReading: newFilterObj.CurrentMeterReading.max || undefined,
    //   }),
    //   ...(newFilterObj?.UnitConsumption && {
    //   minUnitConsumption: newFilterObj?.UnitConsumption?.min || undefined,
    //   maxUnitConsumption: newFilterObj?.UnitConsumption?.max || undefined,
    // }),
    // }))
    if (selectedOption === "Consumption by Equipment") {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj, // Directly merge newFilterObj when selectedOption matches
      }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        ...(newFilterObj?.PreviousMeterReading && {
          minPreviousMeterReading:
            newFilterObj.PreviousMeterReading.min || undefined,
          maxPreviousMeterReading:
            newFilterObj.PreviousMeterReading.max || undefined,
        }),
        ...(newFilterObj?.CurrentMeterReading && {
          minCurrentMeterReading:
            newFilterObj.CurrentMeterReading.min || undefined,
          maxCurrentMeterReading:
            newFilterObj.CurrentMeterReading.max || undefined,
        }),
        ...(newFilterObj?.UnitConsumption && {
          minUnitConsumption: newFilterObj.UnitConsumption.min || undefined,
          maxUnitConsumption: newFilterObj.UnitConsumption.max || undefined,
        }),
      }));
    }

    console.log("Applied Filters:", newFilterObj);
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleToggle = (option, url) => {
    console.log(url, option, "for the Toggle checking the url");
    setSelectedOption(option);
    setUrl(url);
    SetHeading(
      toggleData?.[0]?.title === option
        ? heading
        : toggleData?.[1]?.title === option
        ? heading2
        : null
    );
    // setData([]);
    // setDoc([]);
    setcolumnWidth(
      toggleData?.[0]?.title === option
        ? user?.companyAdmin
          ? "12% 15% 15% 15% 15% 16% 8%"
          : "12% 20% 20% 18% 18% 8%"
        : user?.companyAdmin
        ? "11% 14% 13% 12% 13% 11% 14% 8%"
        : "12% 15% 13% 16% 16% 16% 8%"
    );
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0].title);
    setUrl(toggleData?.[0].url);
  }, []);

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
        <>
          <TopMenu
            {...{
              setDrawerFilterOpen: setIsFilterModalOpen,
              selectedMonth,
              setSelectedMonth,
              selectedYear,
              setSearchQuery,
              setSelectedYear,
              selectedOption,
              handleToggle,
              filterApplied: isFilterModalOpen,
              toggleData,
              fromDate,
              setFromDate,
              toDate,
              setToDate,
              selectedFacility,
              setSelectedFacility,
            }}
            heading={"Heat"}
          />
          <Box
            sx={{
              backgroundColor: "#ededed",
            }}
          >
            <TableDocument
              data={data}
              page={page}
              totalPages={totalPages}
              headers={toggleHeding}
              columnWidth={columnWidth}
              //   columnWidth={toggleData?.[0]?"10% 20% 15% 15% 15% ":"11% 18% 20% 20% 18% 8%"}
            />
          </Box>
          <FilterModal
            isOpen={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            filters={
              selectedOption === "Consumption by Equipment"
                ? filterData
                : filterData2
            }
            onFilterChange={handleFilterChange}
            title="Filter"
          />
        </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default Main;
